import classesText from './ccf-app-agent-messages.module.scss';

import { ConversationsAppSideBar } from './conversations-app-sidebar/conversations-app-sidebar';
import { ConversationsAppHeader } from './conversations-app-header/conversations-app-header';
import { ConversationsAppContainer } from './conversations-app-container/conversations-app-container';
import { ConversationsReplyAppContainer } from './conversations-reply-app-container/conversations-reply-app-container';
import { ConversationsAppFooter } from './conversations-app-footer/conversations-app-footer';
import { Paper, Divider, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { CONVERSATION_SEARCH_HEIGHT } from './utils/conversations.utils';
import { ConversationAppSearch } from './conversations-app-search/conversations-app-search';
import {
  CcfBox,
  CcfConversationIcon,
  CcfEditWithPenIcon,
  CcfHeader,
} from '@nice-ccf/ui-controls';
import { ConversationsAppRightSideBar } from './conversations-app-rightSidebar/conversations-app-rightSidebar';
import { ccfConversationsActions } from './+state/ccf-conversations.slice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { agentsData } from './mock-data/agent-conversations-mock-data';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      margin: 'auto',
      height: '100%',
      boxShadow: 'none',
    },
    textField: {
      zIndex: theme.zIndex.drawer + 1,
      background: theme.palette.background.paper,
      '& > .MuiInputBase-root': {
        height: 32,
        fontSize: 'small',
      },
    },
    header: {
      padding: '8px 16px',
      background: theme.palette.background.level1,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    displayFlex: {
      display: 'flex',
    },
    flexDirectionColumn: {
      flexDirection: 'column',
    },
    contentContainer: {
      borderTop: '1px Solid #e3e9ee',
      height: `calc( 100% - ${CONVERSATION_SEARCH_HEIGHT}px )`,
    },
    conversationContent: {
      height: '100%',
      width: '100%',
      padding: '0px 10px',
    },
    headerText: {
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '12px',
      lineHeight: '16px',
      color: '#3f5c69',
    },
    leftSideBar: {
      width: '30%',
      borderRight: '1px solid #e3e9ee',
    },
  })
);

/* eslint-disable-next-line */
export interface CcfAppAgentMessagesProps {}

/**
 * Component for Conversations feature
 * @param props - CcfAppAgentMessagesProps
 * @example <CcfAppAgentMessages />
 * @returns
 */
export function CcfAppAgentMessages(props: CcfAppAgentMessagesProps) {
  const styles = useStyles();
  const dispatch = useDispatch();
  const { updateSelectedAgent, updateAgentGroups, updateAgents } =
    ccfConversationsActions;

  useEffect(() => {
    dispatch(updateSelectedAgent({ agent: agentsData[0], type: 'favourite' }));
    dispatch(updateAgentGroups({ type: 'reset' }));
    dispatch(updateAgents({ type: 'reset' }));
  }, []);
  return (
    <Paper className={styles.root} square>
      <CcfBox className={classesText.headerContainer}>
        <CcfHeader
          headerText="Messages"
          LeftIcon={
            <CcfConversationIcon fillColour="#007AB8" fontSize="small" />
          }
          RightIcon={false}
          headerTextClassess={classesText.headerText}
        />
      </CcfBox>

      <section className={`${styles.displayFlex} ${styles.contentContainer}`}>
        <CcfBox className={styles.leftSideBar}>
          <ConversationAppSearch showSearchBox={true} />
          <ConversationsAppSideBar />
        </CcfBox>

        <CcfBox
          className={`${styles.displayFlex} ${styles.flexDirectionColumn} ${styles.conversationContent} `}
        >
          <ConversationsAppContainer />
          <Divider style={{ marginBottom: '10px' }} />
          <ConversationsReplyAppContainer />
        </CcfBox>
      </section>
    </Paper>
  );
}

export default CcfAppAgentMessages;
